const languagePairLocale = {
  emptyText: "Not set"
};
export {
  languagePairLocale
};
//# sourceMappingURL=en_US.js.map
